module.exports = __webpack_public_path__ + "static/media/icon-supplies-robetowel.730f4942.svg";